module.exports = __webpack_public_path__ + "static/media/alert.80d37618.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/alert.mp3
// module id = 1053
// module chunks = 0